import React from 'react';
export const DevToolsModuleBridge = function EmptyComponent() { return null; };
